import React, { useEffect, useState } from "react";
import SearchableDropdown from "./Common/SearchableDropdown";
import { getDropdownOptions } from "./common";
import { getCategories } from "../api/categories";

const JobSearch = ({ setQuery, query }) => {
  const [categories, setCategories] = useState([]);
  const [loading, setLoading] = useState(false);

useEffect(() => {
    setLoading(true);

    getCategories()
      .then((res) => {
        // Axios uses res.data for the response body. 
        // Your API wraps the array inside an actual "data" property.
        const arrayData = res?.data?.data || []; 
        
        console.log("Categories Array:", arrayData); // Should now log the raw array [...]
        setCategories(arrayData); 
      })
      .catch((err) => {
        console.error("FULL ERROR:", err);
      })
      .finally(() => {
        setLoading(false);
      });
  }, []);

  return (
    <React.Fragment>
      <SearchableDropdown
        options={getDropdownOptions(categories, {
          label: "name",   // ⚠️ change if API field is different
          value: "name",
        })}
        value={query}
        onChange={setQuery}
        placeholder="Designation (Optional)"
        leftIcon={<i className="uil uil-briefcase-alt"></i>}
        isCreatable={true}
        sortOptionsAlphabetically
        isLoading={loading} // ✅ optional (if supported)
      />
    </React.Fragment>
  );
};

export default JobSearch;